// Звёзды и режим «Прораб» — чистая математика, общая для сервера и клиента
// (esbuild подтягивает CJS в бандл). Звёзды считает ТОЛЬКО сервер из данных
// забега, прошедших античит; клиентского поля «stars» в протоколе нет вовсе.
//
// Лестница кумулятивная:
//   1⭐ — здание достроено;
//   2⭐ — достроено с потерей не больше 1 жизни;
//   3⭐ — вторая звезда + доля перфектов >= порога уровня (starPerfectShare).
// Потерянные жизни сервер ВЫВОДИТ сам: каждый тап — либо этаж, либо срыв,
// поэтому livesLost = taps - floors. Клиенту тут врать нечем: и taps, и
// floors уже зажаты античитом.

function starsForRun({ floors, levelFloors, perfects, taps, share }) {
  const f = Number(floors), p = Number(perfects), t = Number(taps);
  if (!(f > 0) || f !== Number(levelFloors)) return 0;
  const livesLost = Math.max(0, t - f);
  if (livesLost > 1) return 1;
  if (!(p / f >= Number(share))) return 2;
  return 3;
}

// «Прораб»: маятник ×1.3, зона PERFECT ×0.7, очки ×2. Открывается за 3⭐.
const FOREMAN = { speedScale: 1.3, perfectScale: 0.7, scoreMultiplier: 2 };

// Клон уровня с прорабскими модификаторами — используется клиентом для игры;
// сервер валидирует тем же скейлом очков (validateRun scoreMultiplier)
function foremanLevel(level) {
  const p = level.pendulum;
  return {
    ...level,
    foreman: true,
    subtitle: `${level.subtitle} · ПРОРАБ ×2`,
    pendulum: {
      ...p,
      speedStart: p.speedStart * FOREMAN.speedScale,
      speedMax: p.speedMax * FOREMAN.speedScale,
      speedPerFloor: p.speedPerFloor * FOREMAN.speedScale,
    },
  };
}

// Порог доли перфектов для 3⭐: свой у уровня, иначе общий из physics
function perfectShare(level, physics) {
  return level.starPerfectShare != null ? level.starPerfectShare
    : (physics.starPerfectShare != null ? physics.starPerfectShare : 0.5);
}

// Вклад звёзд в общий зачёт рейтинга (формула задокументирована в README)
const STAR_BONUS = 250;

module.exports = { starsForRun, foremanLevel, perfectShare, FOREMAN, STAR_BONUS };
